import Layout from '@/layouts/index.vue';

export default [
  {
    path: '/guarantee',
    name: 'Guarantee',
    component: Layout,
    redirect: '/guarantee/base',
    meta: {
      title: '投标保函',
      icon: 'file-safety',
      permission: 'guarantee',
    },
    children: [
      {
        path: 'base',
        name: 'GuaranteeBase',
        component: () => import('@/pages/guarantee/base/index.vue'),
        meta: {
          title: '保函管理',
          permission: 'guaList',
        },
      },
      {
        path: 'detail',
        name: 'GuaranteeDetail',
        component: () => import('@/pages/guarantee/base/components/detail.vue'),
        meta: {
          hidden: true,
          permission: 'guaList',
          hiddenBreadcrumb: false,
          keepAlive: false,
          title: '保函详情',
        },
      },
      {
        path: 'invoice',
        name: 'GuaranteeInvoice',
        component: () => import('@/pages/guarantee/invoice/index.vue'),
        meta: {
          title: '发票管理',
          permission: 'invoice',
        },
      },
    ],
  },

  {
    path: '/agency',
    name: 'Agency',
    component: Layout,
    redirect: '/agency/trade',
    meta: {
      title: '机构管理',
      icon: 'tree-round-dot-vertical',
      permission: 'agency',
    },
    children: [
      {
        path: 'trade',
        name: 'AgencyTrade',
        component: () => import('@/pages/agency/trade/index.vue'),
        meta: {
          title: '交易机构',
          permission: 'agencyTrade',
        },
      },
      {
        path: 'letter',
        name: 'AgencyLetter',
        component: () => import('@/pages/agency/letter/index.vue'),
        meta: {
          title: '出函机构',
          permission: 'agencyLetter',
        },
      },
    ],
  },

  // {
  //   path: '/offlineGuarantee',
  //   name: 'OfflineGuarantee',
  //   component: Layout,
  //   redirect: '/offlineGuarantee/audit',
  //   meta: {
  //     title: '保函管理',
  //     icon: 'file-safety',
  //     permission: 'offlineGuarantee',
  //   },
  //   children: [
  //     {
  //       path: 'audit',
  //       name: 'OfflineGuaranteeAudit',
  //       component: () => import('@/pages/offlineGuarantee/audit/index.vue'),
  //       meta: {
  //         title: '保函列表',
  //         permission: 'offlineGuaList',
  //       },
  //     },
  //     {
  //       path: 'institution',
  //       name: 'OfflineGuaranteeInstitution',
  //       component: () => import('@/pages/offlineGuarantee/institution/index.vue'),
  //       meta: {
  //         title: '机构管理',
  //         permission: 'offlineGuaInstitution',
  //       },
  //     },
  //     {
  //       path: 'format',
  //       name: 'OfflineGuaranteeFormat',
  //       component: () => import('@/pages/offlineGuarantee/format/index.vue'),
  //       meta: {
  //         title: '格式管理',
  //         permission: 'offlineGuaFormat',
  //       },
  //     },
  //     {
  //       path: 'template',
  //       name: 'OfflineGuaranteeTemplate',
  //       component: () => import('@/pages/offlineGuarantee/template/index.vue'),
  //       meta: {
  //         title: '模板管理',
  //         permission: 'offlineGuaTemplate',
  //       },
  //     },
  //     {
  //       path: 'material',
  //       name: 'OfflineGuaranteeMaterial',
  //       component: () => import('@/pages/offlineGuarantee/material/index.vue'),
  //       meta: {
  //         title: '材料管理',
  //         permission: 'offlineGuaMaterial',
  //       },
  //     },
  //   ],
  // },
  {
    path: '/subUser',
    name: 'SubUser',
    component: Layout,
    redirect: '/subUser/base',
    meta: {
      title: '子账户管理',
      icon: 'usergroup',
      single: true,
      hidden: true,
      permission: 'user',
    },
    children: [
      {
        path: 'base',
        name: 'SubUserBase',
        component: () => import('@/pages/subUser/base/index.vue'),
        meta: {
          title: '子账户管理',
          permission: 'user',
        },
      },
    ],
  },

  {
    path: '/consumer',
    name: 'Consumer',
    component: Layout,
    redirect: '/consumer/base',
    meta: {
      title: '企业管理',
      icon: 'user',
      single: true,
      permission: 'consumer',
    },
    children: [
      {
        path: 'base',
        name: 'ConsumerBase',
        component: () => import('@/pages/consumer/base/index.vue'),
        meta: {
          title: '企业管理',
          permission: 'consumer',
        },
      },
    ],
  },
  {
    path: '/system',
    name: 'System',
    component: Layout,
    redirect: '/system/permission',
    meta: {
      title: '系统设置',
      icon: 'setting',
      permission: 'system',
    },
    children: [
      {
        path: 'permission',
        name: 'SystemPermission',
        component: () => import('@/pages/system/permission/index.vue'),
        meta: {
          title: '权限管理',
          permission: 'permission',
        },
      },
      {
        path: 'role',
        name: 'SystemRole',
        component: () => import('@/pages/system/role/index.vue'),
        meta: {
          title: '角色管理',
          permission: 'role',
        },
      },
      {
        path: 'user',
        name: 'SystemUser',
        component: () => import('@/pages/system/user/index.vue'),
        meta: {
          title: '用户列表',
          permission: 'user',
        },
      },
      {
        path: 'subAdmin',
        name: 'SystemSubAdmin',
        component: () => import('@/pages/subUser/base/index.vue'),
        meta: {
          title: '子账户管理',
          permission: 'subAdmin',
        },
      },
    ],
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Layout,
    redirect: '/setting/base',
    meta: {
      title: '平台设置',
      icon: 'setting',
      permission: 'platformSetting',
    },
    children: [
      {
        path: 'base',
        name: 'SettingBase',
        component: () => import('@/pages/setting/base/index.vue'),
        meta: {
          title: '平台信息',
          permission: 'platformSettingEdit',
        },
      },
      {
        path: 'codes',
        name: 'SMSCodes',
        component: () => import('@/pages/sms/index.vue'),
        meta: {
          title: '短信验证码',
          permission: 'SMSCodes',
        },
      },
    ],
  },
];
